import * as React from 'react'
import * as T from 'components/ui/typography'

import OutlinedBox from 'components/shared/outlined-box'
import { Progress } from 'components/ui/progress'

import { useSubjects } from 'hooks/swr'

interface ProgressBox {
    subject?: Subject
    isLesson?: boolean
    readedParagraphs?: string[]
}

const ProgressBox = ({ subject, isLesson }: ProgressBox) => {
    const { data: theoryData } = useSubjects()

    // const renderInfoText = React.useCallback(() => {
    //     if (isLesson)
    //         return (
    //             <>
    //                 Hai completato {readedParagraphs?.length} argomento su {subject?.lesson.paragraphs.length}
    //             </>
    //         )
    //     if (!isLesson && subject)
    //         return (
    //             <>
    //                 Hai completato {subject?.sub_subjects_completed?.length || 0} materie su{' '}
    //                 {subject?.sub_subjects_size}
    //             </>
    //         )
    //     else
    //         return (
    //             <>
    //                 Hai completato {theoryData?.theory_status.subjects_completed} materie su{' '}
    //                 {theoryData?.theory_status.subjects_size}
    //             </>
    //         )
    // }, [
    //     isLesson,
    //     readedParagraphs,
    //     subject,
    //     theoryData?.theory_status.subjects_completed,
    //     theoryData?.theory_status.subjects_size,
    // ])

    const quizDone = subject?.quiz_done ? 1 : 0

    const renderValue = React.useCallback(() => {
        if (isLesson)
            return (
                ((subject?.paragraphs_completed.length || 0) + quizDone) /
                ((subject?.lesson?.paragraphs.length || 0) + 1)
            )
        if (!isLesson && subject)
            return (subject?.sub_subjects_completed?.length || 0) / (subject?.sub_subjects_size || 0)
        else return (theoryData?.theory_status.subjects_completed || 0) / (theoryData?.theory_status.subjects_size || 0)
    }, [
        isLesson,
        subject,
        theoryData?.theory_status.subjects_completed,
        theoryData?.theory_status.subjects_size,
        quizDone,
    ])

    return (
        <OutlinedBox className="flex p-4 w-full !rounded-lg justify-between  gap-5">
            <div className="flex-1">
                <T.Large className="my-px">Progresso</T.Large>
                <Progress className="rounded-sm h-[12px] my-2" value={renderValue() * 100} />

                {/* <T.Muted className="text-xs">{renderInfoText()}</T.Muted> */}
            </div>
            <div className="flex items-center">
                <div className="bg-primary rounded-sm flex-1 flex items-center aspect-square py-3 px-2">
                    <T.Large className="text-white">
                        <>{(renderValue() * 100).toFixed(0)}%</>
                    </T.Large>
                </div>
            </div>
        </OutlinedBox>
    )
}

export default ProgressBox
